import { defineStore } from "pinia";
import Services from '@/services/sutting/typeInjuriesServices'
import { mapList, mapTypeInjury } from '@/helpers/mapFuncs'

export const useTypeInjuriesStore = defineStore("typeInjuries", {
persist: true,
state:()=>({
    typeInjury: {},
    typeInjuries: [],
}),
getters : {
    getTypeInjury() {
        return mapTypeInjury(this.typeInjury)
    },
    getTypeInjuries() {
        return this.typeInjuries.map(mapTypeInjury)
    },
    getTypeInjuriesList() {
        return this.typeInjuries.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setTypeInjury(typeInjury) {
        this.typeInjury = typeInjury
    },
    setTypeInjuries(typeInjuries) {
        this.typeInjuries = typeInjuries
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setTypeInjury(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setTypeInjuries(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.typeInjuries.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.typeInjuries[this.typeInjuries.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.typeInjuries = this.typeInjuries.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
